<div class="container">
    <h1 class="container__title">Edytuj pojazd</h1>

    <p-floatlabel class="container__input" variant="in">
        <input pInputText id="in_label" [(ngModel)]="vehicleName" autocomplete="off" />
        <label for="in_label">Nazwa pojazdu</label>
    </p-floatlabel>

    <div class="container__actions">
        <p-button
            (onClick)="submit()"
            class="submit-btn"
            [label]="'Zapisz zmiany'|translate"
            [loading]="false"
        />
        <p-button (onClick)="cancel()" label="Anuluj" icon="pi pi-times" variant="text" severity="secondary" />
    </div>
</div>
